import { ConteosEscaneoProvider } from "./ConteosEscaneoContext";

export const AllConteosEscaneoProvider = (props) => (
  <ConteosEscaneoProvider>
    {props.children}
  </ConteosEscaneoProvider>
);
